<mat-card appearance="outlined">
  <mat-card-title [innerText]="'MAIN_APP_CAMERA.fotoAufnehmen' | translate"></mat-card-title>
  <mat-card-content>
    <div style="text-align: center">
      <div *ngIf="!canSave">
        <webcam [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)"
          (initError)="handleInitError($event)"></webcam>
      </div>
      <div *ngIf="webcamImage">
        <h3>{{ "MAIN_APP_CAMERA.bildvorschau" | translate }}</h3>
	      <img [src]="webcamImage.imageAsDataUrl"
             alt="img"/>
      </div>
    </div>
  </mat-card-content>
  <mat-dialog-actions>
    <button mat-mini-fab (click)="triggerSnapshot()">
      <mat-icon>photo_camera</mat-icon>
    </button>
    <button mat-mini-fab [disabled]="!canSave" (click)="clearImage()">
      <mat-icon>delete</mat-icon>
    </button>
    <button mat-mini-fab (click)="showNextWebcam(true)" [disabled]="!multipleWebcamsAvailable">
      <mat-icon>cameraswitch</mat-icon>
    </button>
	  <button (click)="save()" [disabled]="!canSave" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_CAMERA.abbrechen' | translate"></button>
  </mat-dialog-actions>
</mat-card>
